import { Layout, Col, Row } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import IconoCerrarSesion from '../../../img/cerrar_sesion.svg';
import flecha from '../../../img/flecha.png';
import userIcon from '../../../img/user_icon.png';
import menuIcon from '../../../img/menu_icon.png';
import idSistema from '../../../img/logo_recluta.svg';
import cauIcon from '../../../img/cau_icon.png';
import { obtenerFormatoDistrito, obtenerEstado } from '../../../utils/funciones.js';
import * as etiquetas from '../../../ApplicationResources';
import { obtenerEdoDtoAspirante } from '../../../redux/user/user-utils';
import { setEstadoDistritoAspirante } from '../../../redux/user/user-actions';

let nombreUsuario = "";
let nivelUsuario = "";
let rolUsuario = "";

const { Header } = Layout;

class HeaderInterno extends Component {
	constructor(props) {
		super(props);

        // Obtenemos el tipo de usuario de la store de redux
		var tipoUsuario = this.props.haySesion ?
			this.props.datosUsuario.tipoUsuario : "";

        // Si el tipo de usuario es interno o externo
        if(tipoUsuario === 'I' || tipoUsuario === 'E') {
            // Consultamos el rol del usuario y su nivel para mostrar en la etiqueta correspondiente
            this.obtenerRolUsuario();
            this.obtenerNiveles(tipoUsuario);
        }

        // Inicializamos valores que se usan para mostrar u ocultar el menú y la información propia
        // de la sesión del usuario interno
		this.state = {
			mostrarOcultarInfo: false
		};
	}

	/**
	* Obtiene el rol de usuario OC, Jl o JD
	**/
	obtenerRolUsuario = () => {
		var usuarioRol = this.props.haySesion ? this.props.datosUsuario.rolUsuario
			: "";
		rolUsuario = usuarioRol.substr(-2, 2);
		if (rolUsuario === 'JD') {
			this.mostrarBarchart = true;
		}
	}

	obtenerNiveles = (tipoUsuario) => {
		if (tipoUsuario !== "" && tipoUsuario === "E") {
			this.obtenerNivelUsuarioE();
		} else if (tipoUsuario !== "" && tipoUsuario === "I") {
			nombreUsuario = this.props.haySesion ? this.props.datosUsuario.username : "";
			this.obtenerNivelUsuarioI();
		}
	}

	/**
	* Obtiene el nivel del aspirante
	**/
	obtenerNivelUsuarioE = () => {
		const {datosAspirante} = this.props;
		
		if(!datosAspirante)
			return;

		nombreUsuario = datosAspirante.nombre ? datosAspirante.nombre : "";
		const idProcesoElectoral = datosAspirante.idProcesoElectoral ? datosAspirante.idProcesoElectoral : 0;
		const idDetalleProceso = datosAspirante.idDetalleProceso ? datosAspirante.idDetalleProceso : 0;
		const idParticipacion = datosAspirante.idParticipacion ? datosAspirante.idParticipacion : 0;

		var postData = {
			idProcesoElectoral: idProcesoElectoral,
			idDetalleProceso: idDetalleProceso,
			idParticipacion: idParticipacion
		};

		// Llamamos la función desde user-utils para obtener el estado y distrito
		// del aspirante
		if(this.props.estadoDistritoAspirante !== undefined) {
			// Si el estadoDistritoAspirante está definido
			this.actualizarEstadoDistritoAspirante(
				this.props.estadoDistritoAspirante);
		} else {
			// Si el estadoDistritoAspirante está indefinido
			obtenerEdoDtoAspirante(postData).then(datos => {
				this.props.setEstadoDistritoAspirante(datos);
				this.actualizarEstadoDistritoAspirante(datos);
			});
		}
	}

	/**
	 * Función que actualiza el estado y distrito del aspirante externo
	 */
	actualizarEstadoDistritoAspirante(datos){
		var distrito = 0;

		distrito = obtenerFormatoDistrito(datos[0].idDistrito);
		nivelUsuario = distrito + " " + datos[0].nombreEstado;
		this.setState({ clave: nivelUsuario })
	}

	/**
	* Obtiene el nivel para el usuario JD
	**/
	obtenerNivelUsuarioI = () => {

		var usuarioRol = this.props.haySesion ? this.props.datosUsuario.rolUsuario : "";
		var idEstado = this.props.haySesion ? this.props.datosUsuario.idEstado : "";
		var idDistrito = this.props.haySesion ? this.props.datosUsuario.idDistrito : "";
		var nombreEstado = obtenerEstado(idEstado);
		var distrito = obtenerFormatoDistrito(idDistrito);

		var rol_div = usuarioRol.split(".");
		var nivel = rol_div[1].split("_");

		if (nivel.length === 2) {
			rolUsuario = nivel[1];
			nivelUsuario = rolUsuario + " " + distrito + " " + nombreEstado;
		} else {
			switch (rolUsuario) {
				case 'JL':
					nivelUsuario = rolUsuario + " " + distrito + " " + nombreEstado;
					break;
				case 'JD':
					nivelUsuario = rolUsuario + "E " + distrito + " " + nombreEstado;
					break;
				case 'OC':
					nivelUsuario = "DECEyEC";
					break;
			}
		}
	}

	mostrarInfoUsuario = () => {
		this.setState(prevState => ({
			mostrarOcultarInfo: !prevState.mostrarOcultarInfo
		}));
	}

	redireccionar = () => {
		this.props.history.push('/logout');
	}

    render() {
        // Obtenemos el tipo de usuario de la store de redux
		var tipoUsuario = this.props.haySesion ?
			this.props.datosUsuario.tipoUsuario : "";

        return (
            <div>
                <Header className="header_interno">
                    <Col xs={16} sm={8} md={8} lg={10}>
                        <Col xs={10} sm={24} md={24} lg={24}>
                            {
                                tipoUsuario === 'E' ?
                                    <img id="idSistema" src={idSistema} alt="" />
                                :
                                    <Link to={tipoUsuario === 'I' ? "/menuJDE" : "/loginSEyCAE"}>
                                        <img id="idSistema" src={idSistema} alt="" />
                                    </Link>
                            }
                        </Col>
                    </Col>
                    <Col xs={8} sm={16} md={16} lg={14}>
                        {this.props.haySesion ?
                            <Col xs={24} sm={24} md={24} lg={24}>
                                <Col xs={1} sm={1} md={3} lg={8} className='ocultar_columna'></Col>
                                <Col xs={6} sm={2} md={2} lg={2} className='ocultar_columna'>
                                    {
                                        tipoUsuario === 'I' ?
                                            <a href={etiquetas.CENTRO_DE_AYUDA}
                                                data-toggle="tooltip" title="Ayuda"
                                                target='_blank'>
                                                <img src={cauIcon} id='question-icon' />
                                            </a>
                                        
                                        : ""
                                    }
                                </Col>
                                <Col xs={1} sm={1} md={1} lg={1} className='ocultar_columna'>
                                    <img src={userIcon} id="user-icon" />
                                </Col>
                                <Col xs={7} sm={7} md={5} lg={4} className="text-user-level">
                                    <div id="label-user-name">{nombreUsuario}</div>
                                    <div id="level-label">{nivelUsuario}</div>
                                </Col>
                                <Col xs={1} sm={1} md={1} lg={1} className='ocultar_columna'>
                                    <div id="division-username-close-sesion">|</div>
                                </Col>

                                <Col xs={6} sm={6} md={6} lg={6} id="div-icon-user-mov">
                                    <div>
                                        <img src={userIcon} id="user-icon" />
                                        <img src={flecha} id="flecha" onClick={this.mostrarInfoUsuario} />
                                    </div>
                                </Col>

                                <Col xs={6} sm={6} md={6} lg={8} className='ocultar_columna'>
                                    <Link to="#" icon="logout" type="" className="link_logout"
                                        onClick={this.redireccionar} >
                                        <img 
                                            src={IconoCerrarSesion} 
                                            alt="Icono cerrar sesión"/>
                                        <span className='logout-style'>Cerrar sesión</span>
                                    </Link>
                                </Col>
                            </Col>


                        : ""}
                    </Col>
                </Header>
                <div id="info-user-mov"
                    className={this.state.mostrarOcultarInfo ? "show" : "hide"}>
                    <img src={userIcon} id="user-icon" />
                    {this.props.haySesion ?
                        <>
                            <p id="user-name-mov">
                                {nombreUsuario}
                            </p>
                            <p id="nivel-mov">
                                {nivelUsuario}
                            </p>
                        </>
                        : ""}
                    <hr />

                    {
                        tipoUsuario === 'I' ? 
                            <p className="otras_opciones">
                                <a href={etiquetas.CENTRO_DE_AYUDA} target="_blank">Ayuda</a>
                            </p>
                        : ""
                    }
                    <p className="otras_opciones">
                        {this.props.haySesion ? 
                            <a
                                onClick={this.redireccionar} id="boton-logout">
                                Cerrar sesión
                            </a>
                            : ""
                        }
                    </p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		haySesion: Boolean(state.user.currentUser && state.user.currentUser.username),
		datosUsuario: state.user.currentUser,
		datosAspirante: state.user.datosAspirante,
		estadoDistritoAspirante: state.user.estadoDistritoAspirante
	};
};

const mapDispatchToProps = dispatch => ({
	setEstadoDistritoAspirante: estadoDistrito => dispatch(setEstadoDistritoAspirante(estadoDistrito))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderInterno));